module.exports = __webpack_public_path__ + "static/Sahel-Bold-e31f9d9b0053eb6cffd8b93983526288.woff2";